<div class="row" style="max-width: 1180px">
    <div class="col-md-4">
        <div class="card">
            <div class="card-body">
                <my-image-cropper
                    [initialImage]="initialImage"
                    (imageChange)="imageChanged($event)"
                >
                    <p>Add an image to white-label your dashboard and customer communications.</p>
                </my-image-cropper>
            </div>
        </div>
    </div>

    <div class="col-md-8">
        <div class="card">
            <div class="card-body">
                <form [formGroup]="resellerForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="form-label form-label-required" for="name">
                            {{ 'reseller-form.nameLabel' | translate }}
                        </label>

                        <input 
                            class="form-control"
                            formControlName="name" 
                            id="name" 
                            name="name"
                            placeholder="{{ 'reseller-form.namePlaceholder' | translate }}" 
                            type="text"
                            [class.invalid-field]="resellerForm.get('name').dirty && resellerForm.get('name').invalid"
                            [readonly]="!permissions.addResellers"
                        />
                    </div>

                    <div class="form-group">
                        <label class="form-label form-label-required" for="siteURL">
                            {{ 'reseller-form.siteURLLabel' | translate }}
                        </label>

                        <input 
                            [readonly]="!permissions.addResellers"
                            formControlName="siteURL" 
                            name="siteURL" id="siteURL" 
                            placeholder="{{ 'reseller-form.siteURLPlaceholder' | translate }}" 
                            type="text"
                            class="form-control"
                            [class.invalid-field]="resellerForm.get('siteURL').dirty && resellerForm.get('siteURL').invalid"
                        />
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="availableLicenses">
                            {{ 'reseller-form.availableLicensesLabel' | translate }}
                        </label>

                        <input 
                            class="form-control"
                            formControlName="availableLicenses" 
                            id="availableLicenses" 
                            name="availableLicenses"
                            min="0"
                            placeholder="{{ 'reseller-form.availableLicensesPlaceholder' | translate }}" 
                            pKeyFilter="pint"
                            type="number"
                            [class.invalid-field]="resellerForm.get('availableLicenses').dirty && resellerForm.get('availableLicenses').invalid"
                            [readonly]="!permissions.updateLicensesResellerAdmin"
                        />
                    </div>
                    <div class="section-used-license-container">
                        <label class="form-label" for="name">
                            {{ 'reseller-form.usedLicensesLabel' | translate }}
                        </label>
                        <label class="form-label" for="name">
                            {{ this.reseller.usedLicenses }}
                        </label>
                    </div>
                    <div class="form-group section-fav-icon-container">
                        <label class="form-label" for="name">
                            {{ 'reseller-form.favIconLabel' | translate }}
                        </label>

                        <input 
                            #imagePublicInput2
                            accept=".ico"
                            hidden
                            type="file"
                            [readonly]="!permissions.addResellers"
                            (change)="uploadFavIcon($event.target)"
                        />

                        <div class="section-photo">
                            <img
                                *ngIf="resellerForm.value.favIcon"
                                [attr.src]="sanitizer.bypassSecurityTrustResourceUrl(resellerForm.value.favIcon)"
                                (click)="imagePublicInput2.click()"
                            />

                            <div
                                *ngIf="resellerForm.value.favIcon != emptyReseller.favIcon"
                                class="section-delete-photo"
                                (click)="removeFavIcon()"
                            >
                                <p class="delete-icon">X</p>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mt-2">
                        <button
                            class="btn btn-primary me-2"
                            type="submit"
                            [disabled]="!resellerForm.valid"
                        >
                            {{ (!create ? 'reseller-form.editBusinessButton' : 'reseller-form.createBusinessButton') | translate }}
                        </button>

                        <button class="btn btn-outline-primary" (click)="cancel.emit()">
                            {{ 'reseller-form.cancelButton' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
